import React, {Component} from 'react'
import { Route, Switch } from 'react-router-dom'
import {Row, Col, Card} from 'reactstrap'
import PeopleList from '../../components/People/PeopleList'
import Person from '../../components/People/Person'
import GroupsList from '../../components/People/GroupsList'

export default class People extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="12">
            <Card>
              <Switch>
                <Route exact path="/people" component={PeopleList}/>
                <Route exact path="/people/groups" component={GroupsList}/>
                <Route exact path="/people/:id" component={Person}/>
              </Switch>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/People/People.js